import "./setting.css";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useHistory } from "react-router";
import { styled } from "@material-ui/core";
import { Tab, Tabs } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";
import { PhotoCamera } from "@material-ui/icons";
import { logout } from "../../redux/reducers/user";
import { setUser } from "../../redux/reducers/user";
import { FormButton } from "../../components/form";
import { setAlert } from "../../redux/reducers/alert";
import { useDispatch, useSelector } from "react-redux";
import { validateNumber } from "../../util/validation";
import TabPanel from "../../components/tabPanel/tabPanel";
import React, { useState, useReducer, useEffect, useRef } from "react";
import { BLUE_EIGHT, GRAY_FOURTEEN, WHITE } from "../../theme";
import { VisibilityOffIcon, VisibilityOnIcon } from "../../assets/svg";
import { getUserInfo, resetPassword, updateUserInfo } from "../../api/auth";
import {
  Avatar,
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@material-ui/core";

const Input = styled("input")({
  display: "none",
});

export const Settings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showReenterPassword, setShowReenterPassword] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  const [dialCode, setDialCode] = useState(null);

  const phoneInputRef = useRef(null);
  //* Use this state to store the userInfo data and also Update the state for update UserInfo
  const [UserData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    countryCode: "",
    file: "",
  });
  const [loading, setLoading] = useState(false);
  var [base64, setbase64] = useState(null);
  const user = useSelector((state) => state.user);
  //*  for get and set the items in local Storage
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  //! Message Alert
  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  //! Message Alert

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };
  //* for get UserInfo from Api
  useEffect(() => {
    (async () => {
      setLoading(true);
      const response = await getUserInfo(user.id, user.token);
      if (response.status) {
        setUserData({
          id: response.user.id,
          firstName: response.user.firstName,
          lastName: response.user.lastName,
          email: response.user.email,
          phone: response.user.countryCode + response.user.phone,
          countryCode: response.user.countryCode,
          file: response.user.file,
        });
      }
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (phoneInputRef.current) {
      const dialCode = phoneInputRef.current.state.selectedCountry.dialCode;
      if (dialCode) {
        setDialCode(dialCode);
      }
    }
  }, [phoneInputRef.current]);

  //* using useReducer Hook to pass the initialState and save resetPassword values
  const [
    {
      oldPassword,
      newPassword,
      confirmPassword,
      oldPasswordError,
      newPasswordError,
      confirmPasswordError,
    },
    setData,
  ] = useReducer((state, newState) => ({ ...state, ...newState }), {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    oldPasswordError: false,
    newPasswordError: false,
    confirmPasswordError: false,
  });

  const [tab, setTab] = useState("account");
  //*  for reset user password
  const handlePasswordReset = async () => {
    if (oldPassword === "") {
      setData({ oldPasswordError: true });
      return;
    }
    if (newPassword === "") {
      setData({ newPasswordError: true });
      return;
    }
    if (confirmPassword === "") {
      setData({ confirmPasswordError: true });
      return;
    }
    if (newPassword !== confirmPassword) {
      setData({ newPasswordError: true, confirmPasswordError: true });
      return;
    }

    try {
      const payload = {
        newPassword,
        oldPassword,
        userId: user.id,
      };

      const response = await resetPassword(payload, user.token);
      if (response.status) {
        showSuccessAlert(t("text_password_updated_successfully"));
        local.push({
          message: "Password Updated Successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        localStorage.setItem("notify", JSON.stringify(""));
        window.localStorage.clear();
        dispatch(logout(null));
        history.push("/");
        return;
      } else {
        showErrorAlert(
          response.message || t("text_something_went_wrong_try_again_later")
        );
      }
    } catch (err) {
      showErrorAlert(
        err.message || t("text_something_went_wrong_try_again_later")
      );
    }
  };
  const resetPasswordData = () => {
    setData({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      oldPasswordError: false,
      newPasswordError: false,
      confirmPasswordError: false,
    });
  };

  //* for get the userInfo data values
  const handleChange = (e, countryCode) => {
    if (typeof e === "string") {
      let validIt = validateNumber(e);

      if (validIt) {
        setUserData({
          ...UserData,
          phone: e,
          countryCode: countryCode.dialCode,
        });
      }
    } else {
      setUserData({ ...UserData, [e.target.name]: e.target.value });
    }
    setDisableButton(false);
  };
  const resetUserData = async () => {
    const response = await getUserInfo(user.id, user.token);

    if (response.status) {
      setUserData({
        id: response.user.id,
        firstName: response.user.firstName,
        lastName: response.user.lastName,
        email: response.user.email,
        phone: response.user.phone,
        file: response.user.file,
      });
    }
    showSuccessAlert(t("text_reset_changes_successfully"));
  };
  //* Update userInfo and save in state
  const updateUser = async () => {
    try {
      const removeNonDigit = UserData.phone.replace(/\D/g, "");
      let searchString = UserData.countryCode.length
        ? UserData.countryCode
        : String(dialCode);
      let regex = new RegExp(searchString, "g");
      const customPhone = removeNonDigit.replace(regex, "");
      const formData = new FormData();
      formData.append("firstName", UserData.firstName);
      formData.append("lastName", UserData.lastName);
      formData.append("email", UserData.email);
      formData.append("phone", customPhone);
      formData.append("countryCode", searchString);
      formData.append("file", UserData.file);

      const response = await updateUserInfo(formData, user.id, user.token);
      if (response.status) {
        showSuccessAlert(response?.message);
        //* for save data in localStorage to pushNotify
        local.push({
          message: "User Updated Successfully",
          date: new Date().getTime(),
          newNotification: true,
        });

        dispatch(setUser({ ...user, ...UserData, profileImg: base64 }));
        localStorage.setItem("notify", JSON.stringify(local));
        setDisableButton(true);
        //window.location.reload();
      } else {
        showErrorAlert(response?.message);
      }
    } catch (error) {}
  };
  const fileToBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(null, reader.result);
    };
    reader.onerror = function (error) {
      cb(error, null);
    };
  };

  //* when we have upload a ProfilePic
  const onGetFile = (e) => {
    let fileSize = e.target.files[0].size / 1024 / 1024;
    if (fileSize < 2) {
      setUserData({
        ...UserData,
        [e.target.name]: e.target.files[0],
      });
      fileToBase64(e.target.files[0], (err, result) => {
        if (result) {
          setbase64(result);
          // setFileName(target.files[0])
        }
      });
    } else {
      showErrorAlert(
        t(
          "text_image_size_is_greater_than_2MB_kindly_use_2MB_for_profile_image"
        )
      );
    }
  };
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Typography variant="h4" style={{ marginBottom: 20 }}>
        {t("text_settings")}
      </Typography>
      {loading ? (
        <div className={"setting-loader"}>
          <CircularProgress size={20} style={{ color: "black" }} />
          {t("text_fetching_user_info")}
        </div>
      ) : (
        <>
          <Tabs
            indicatorColor="none"
            textColor="secondary"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="tabs"
          >
            <Tab
              style={{
                backgroundColor: GRAY_FOURTEEN,
                color: WHITE,
                borderRadius: 10,
                marginRight: 15,
                height: 40,
                minHeight: 40,
                width: "11vw",
                fontSize: "0.8vw",
                fontWeight: "700",
                textTransform: "capitalize",
              }}
              label={t("text_account_setting")}
            />
            <Tab
              style={{
                backgroundColor: GRAY_FOURTEEN,
                color: WHITE,
                borderRadius: 10,
                marginLeft: 15,
                height: 40,
                minHeight: 40,
                width: "11vw",
                fontSize: "0.8vw",
                fontWeight: "700",
                textTransform: "capitalize",
              }}
              label={t("text_change_password")}
            />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                alignItems: "center",
                marginBottom: "10px",
                paddingTop: "30px",
              }}
            >
              <span
                className="title-heading"
                style={{
                  color: "black",
                  fontSize: "medium",
                  fontWeight: "700",
                  marginBottom: 10,
                }}
              >
                {t("text_edit_profile")}
              </span>

              <div className="img-box">
                <div className="setting_img">
                  {base64 ? (
                    <img src={base64} alt="" />
                  ) : UserData.file && UserData.file !== "null" ? (
                    <img src={`${UserData.file}`} alt="" />
                  ) : (
                    <Avatar style={{ height: "100%", width: "100%" }} />
                  )}
                </div>
              </div>

              <div style={{ position: "absolute", bottom: "5px", left: "52%" }}>
                <label htmlFor="icon-button-file" style={{ marginBottom: 0 }}>
                  <Input
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    onChange={onGetFile}
                    name="file"
                  />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    style={{ padding: 0 }}
                  >
                    <PhotoCamera />
                  </IconButton>
                </label>
              </div>
            </div>

            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <FormControl
                  variant="outlined"
                  style={{ marginTop: "30px" }}
                  fullWidth
                  size={"small"}
                >
                  <InputLabel htmlFor="outlined-blue-field">
                    {t("text_first_name")}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-blue-field"
                    color={"primary"}
                    onChange={handleChange}
                    value={UserData.firstName}
                    name={"firstName"}
                    style={{ borderRadius: "7px" }}
                    labelWidth={100}
                  />
                </FormControl>
              </Grid>

              <Grid item sm={6} xs={12}>
                <FormControl
                  variant="outlined"
                  style={{ marginTop: "30px" }}
                  fullWidth
                  size={"small"}
                >
                  <InputLabel htmlFor="outlined-blue-field">
                    {t("text_last_name")}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-blue-field"
                    color={"primary"}
                    onChange={handleChange}
                    value={UserData.lastName}
                    name={"lastName"}
                    style={{ borderRadius: "7px" }}
                    labelWidth={100}
                  />
                </FormControl>
              </Grid>

              <Grid item sm={6} xs={12}>
                <FormControl
                  variant="outlined"
                  style={{ marginTop: "16px" }}
                  fullWidth
                  size={"small"}
                >
                  {/*<InputLabel htmlFor="outlined-blue-field">*/}
                  {/*  {t("text_phone_number")}*/}
                  {/*</InputLabel>*/}
                  <ReactPhoneInput
                    ref={phoneInputRef}
                    id="my-phone-input"
                    containerClass="my-phone-input"
                    inputStyle={{
                      width: "inherit",
                      borderRadius: "7px",
                    }}
                    value={UserData.phone}
                    name={"phone"}
                    onChange={handleChange}
                    country={"ae"}
                    specialLabel={t("text_phone_number")}
                  />
                  {/*<OutlinedInput*/}
                  {/*  id="outlined-blue-field"*/}
                  {/*  color={"primary"}*/}
                  {/*  name={"phone"}*/}
                  {/*  onChange={handleChange}*/}
                  {/*  style={{ borderRadius: "7px" }}*/}
                  {/*  value={UserData.phone}*/}
                  {/*  labelWidth={100}*/}
                  {/*/>*/}
                </FormControl>
              </Grid>

              <Grid item sm={6} xs={12}>
                <FormControl
                  variant="outlined"
                  style={{ marginTop: "20px" }}
                  fullWidth
                  size={"small"}
                >
                  <InputLabel htmlFor="outlined-blue-field">
                    {t("text_email_address")}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-blue-field"
                    color={"primary"}
                    name={"email"}
                    disabled
                    onChange={handleChange}
                    style={{ borderRadius: "7px" }}
                    value={UserData.email}
                    labelWidth={100}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <div className="button-wrapper-box">
              <FormButton
                onClickHandler={updateUser}
                backgroundColor={BLUE_EIGHT}
                titleColor={WHITE}
                hoverTitleColor={BLUE_EIGHT}
                hoverBackgroundColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                style={{
                  fontSize: "0.8vw",
                  fontWeight: "700",
                  textTransform: "capitalize",
                  border: `1ps soild ${BLUE_EIGHT}`,
                }}
                loading={loading}
                title={t("text_save_changes")}
                width={"230px"}
                borderTopLeftRadius={15}
                borderTopRightRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                isSetting={true}
                borderColor={BLUE_EIGHT}
              />

              <FormButton
                width={"230px"}
                borderTopRightRadius={15}
                borderTopLeftRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                onClickHandler={resetUserData}
                backgroundColor={BLUE_EIGHT}
                titleColor={WHITE}
                hoverTitleColor={BLUE_EIGHT}
                hoverBackgroundColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                style={{
                  fontSize: "0.8vw",
                  fontWeight: "700",
                  textTransform: "capitalize",
                  border: `1ps soild ${BLUE_EIGHT}`,
                }}
                loading={loading}
                title={t("text_reset_changes")}
                isSetting={true}
                borderColor={BLUE_EIGHT}
              />
            </div>
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <Box
              display="flex"
              justifyContent="center"
              marginBottom={4}
              marginTop={4}
            >
              <span
                className="title-heading"
                style={{
                  color: "black",
                  fontSize: "medium",
                  fontWeight: "700",
                  marginBottom: 10,
                }}
              >
                {t("text_change_password")}
              </span>
            </Box>

            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <FormControl variant="outlined" fullWidth size={"small"}>
                  <InputLabel htmlFor="outlined-blue-field">
                    {t("text_current_password")}
                  </InputLabel>
                  <OutlinedInput
                    type={showOldPassword ? "text" : "password"}
                    error={oldPasswordError}
                    id="outlined-blue-field"
                    color={"primary"}
                    style={{ borderRadius: "7px" }}
                    labelWidth={100}
                    autoComplete="off"
                    onChange={({ target: { value } }) => {
                      setData({
                        oldPassword: value,
                        oldPasswordError: false,
                      });
                    }}
                    endAdornment={
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          style={{
                            width: "2.8vw",
                            color: "#04acdd",
                          }}
                          onClick={() => setShowOldPassword(!showOldPassword)}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showOldPassword ? (
                            <VisibilityOnIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item sm={6} xs={12}>
                <FormControl variant="outlined" fullWidth size={"small"}>
                  <InputLabel htmlFor="outlined-blue-field">
                    {t("text_new_password")}
                  </InputLabel>
                  <OutlinedInput
                    error={newPasswordError}
                    autoComplete="off"
                    type={showNewPassword ? "text" : "password"}
                    id="outlined-blue-field"
                    color={"primary"}
                    value={newPassword}
                    onChange={({ target: { value } }) => {
                      setData({
                        newPassword: value,
                        newPasswordError: false,
                      });
                    }}
                    style={{ borderRadius: "7px" }}
                    labelWidth={110}
                    endAdornment={
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          style={{
                            width: "2.8vw",
                            color: "#04acdd",
                          }}
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showNewPassword ? (
                            <VisibilityOnIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item sm={6} xs={12}>
                <FormControl variant="outlined" fullWidth size={"small"}>
                  <InputLabel htmlFor="outlined-blue-field">
                    {t("text_confirm_new_password")}
                  </InputLabel>
                  <OutlinedInput
                    error={confirmPasswordError}
                    type={showReenterPassword ? "text" : "password"}
                    id="outlined-blue-field"
                    color={"primary"}
                    style={{ borderRadius: "7px" }}
                    labelWidth={135}
                    autoComplete="off"
                    value={confirmPassword}
                    onChange={({ target: { value } }) => {
                      setData({
                        confirmPassword: value,
                        confirmPasswordError: false,
                      });
                    }}
                    endAdornment={
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          style={{
                            width: "2.8vw",
                            color: "#04acdd",
                          }}
                          onClick={() =>
                            setShowReenterPassword(!showReenterPassword)
                          }
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showReenterPassword ? (
                            <VisibilityOnIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>

            <div className="button-wrapper-box">
              <FormButton
                width={"230px"}
                onClickHandler={handlePasswordReset}
                backgroundColor={BLUE_EIGHT}
                titleColor={WHITE}
                hoverTitleColor={BLUE_EIGHT}
                hoverBackgroundColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                style={{
                  fontSize: "0.8vw",
                  fontWeight: "700",
                  textTransform: "capitalize",
                  border: `1ps soild ${BLUE_EIGHT}`,
                }}
                loading={loading}
                title={t("text_save_changes")}
                borderTopLeftRadius={15}
                borderTopRightRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                isSetting={true}
                borderColor={BLUE_EIGHT}
              />

              <FormButton
                width={"230px"}
                onClickHandler={resetPasswordData}
                backgroundColor={BLUE_EIGHT}
                titleColor={WHITE}
                hoverTitleColor={BLUE_EIGHT}
                hoverBackgroundColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                style={{
                  fontSize: "0.8vw",
                  fontWeight: "700",
                  textTransform: "capitalize",
                  border: `1ps soild ${BLUE_EIGHT}`,
                }}
                loading={loading}
                title={t("text_reset_changes")}
                borderTopRightRadius={15}
                borderTopLeftRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                isSetting={true}
                borderColor={BLUE_EIGHT}
              />
            </div>
          </TabPanel>
        </>
      )}
    </div>
  );
};
